// src/components/admin/admintopbar/AdminTopbar.jsx
import React, { useState, useEffect, useRef, useContext } from "react";
import {
  FiSearch,
  FiSun,
  FiMoon,
  FiBell,
  FiUser,
  FiLogOut,
  FiMenu,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../../../assets/css/admin/components/admintopbar/AdminTopbar.css";
import AppContext from "../../../contexts/AppContext";

const AdminTopbar = ({ onToggleSidebar }) => {

  const { admin,setAdmin, baseUrl, unreadCounts, setUnreadCount, clearUnread, adminAuthToken } = useContext(AppContext);
   const adminData = admin || JSON.parse(localStorage.getItem("loggedInAdmin"));

  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem("admin-theme") === "dark";
  });

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);
  const navigate = useNavigate();

  // Fetch unread notification count on mount
  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/notifications/viewAll` ,{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
      })
      .then((res) => {
        const notifications = res.data.notifications || [];
        const unreadCount = notifications.filter((n) => n.status === "unread").length;
        setUnreadCount("notifications", unreadCount);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add("dark-mode");
      document.body.classList.add("dark-mode");
      localStorage.setItem("admin-theme", "dark");
    } else {
      document.documentElement.classList.remove("dark-mode");
      document.body.classList.remove("dark-mode");
      localStorage.setItem("admin-theme", "light");
    }
  }, [isDark]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure you want to logout?",
      text: "You will need to login again to access the admin panel.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6b7280",
      confirmButtonText: "Yes, Logout",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("loggedInAdmin");
        localStorage.removeItem("adminAuthToken");
        setAdmin(null);
        navigate("/admin/login");

        Swal.fire({
          title: "Logged out successfully!",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    });
  };

  const handleBellClick = () => {
    clearUnread("notifications");
    navigate("/admin/notifications");
  };

  return (
    <header className="admin-topbar">
      <div className="admin-topbar-left">
        <button
          className="admin-topbar-hamburger"
          onClick={onToggleSidebar}
          aria-label="Toggle menu"
        >
          <FiMenu />
        </button>
        <h2 className="admin-topbar-title">Admin Panel</h2>
      </div>

      <div className="admin-topbar-right">
        {/* <div className="admin-topbar-search">
          <FiSearch />
          <input placeholder="Search in admin..." />
        </div> */}

        <div className="admin-topbar-actions">
          {/* Theme Toggle */}
          <div
            className={`admin-topbar-toggle ${isDark ? "on" : ""}`}
            onClick={() => setIsDark((prev) => !prev)}
          >
            <FiSun className={!isDark ? "icon-active" : ""} />
            <FiMoon className={isDark ? "icon-active" : ""} />
          </div>

          {/* Notifications Bell with Badge */}
          <button
            className="admin-topbar-icon-btn"
            onClick={handleBellClick}
            style={{ position: "relative" }}
          >
            <FiBell />
            {unreadCounts.notifications > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",
                  background: "#ef4444",
                  color: "#fff",
                  fontSize: "10px",
                  fontWeight: "700",
                  borderRadius: "50%",
                  minWidth: "17px",
                  height: "17px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  lineHeight: 1,
                  padding: "0 3px",
                  pointerEvents: "none",
                }}
              >
                {unreadCounts.notifications > 99 ? "99+" : unreadCounts.notifications}
              </span>
            )}
          </button>

          {/* Profile Dropdown */}
          <div className="admin-topbar-profile-wrap" ref={profileMenuRef}>
            <button
              className="admin-topbar-avatar-btn"
              onClick={() => setShowProfileMenu((prev) => !prev)}
            >
              <div className="admin-topbar-profile-info">
                <div className="admin-topbar-avatar-circle">
                  <FiUser />
                </div>
                {admin && (
                  <div className="admin-topbar-name-email">
                    <span className="admin-topbar-name">{admin.name}</span>
                    <span className="admin-topbar-email">
                      {admin.isSuperAdmin === 1
                        ? "Super Administrator"
                        : "Sub Administrator"}
                    </span>
                  </div>
                )}
              </div>
            </button>

            {showProfileMenu && (
              <div className="admin-profile-dropdown">
                <div className="admin-profile-dropdown-divider" />
                <button
                  className="admin-profile-dropdown-item"
                  onClick={() => {
                    setShowProfileMenu(false);
                    navigate("/admin/profile");
                  }}
                >
                  <FiUser />
                  <span>My Profile</span>
                </button>
                <div className="admin-profile-dropdown-divider" />
                <button
                  className="admin-profile-dropdown-item admin-profile-dropdown-item--danger"
                  onClick={() => {
                    setShowProfileMenu(false);
                    handleLogout();
                  }}
                >
                  <FiLogOut />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminTopbar;